module.exports = __webpack_public_path__ + "img/3.5025f381.png";